import { render, staticRenderFns } from "./cova-reconciliation.vue?vue&type=template&id=c7777184&scoped=true"
import script from "./cova-reconciliation.vue?vue&type=script&lang=js"
export * from "./cova-reconciliation.vue?vue&type=script&lang=js"
import style0 from "./cova-reconciliation.vue?vue&type=style&index=0&id=c7777184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7777184",
  null
  
)

export default component.exports